import { connect } from 'react-redux';
import AdCounter from '../../components/tools/VideoTool/AdCounter';
import * as actions from '../../actions/tools';

const mapStateToProps = state => ({
  adminCheck: state.map.selectedTrack
    ? state.map.selectedTrack.adminCheck
    : 0,
  adminCheckStep: state.map.selectedTrack
    ? state.map.selectedTrack.adminCheckStep
    : 0,
  videoStep: state.tools.videoStep,
});

const mapDispatchToProps = dispatch => ({
  onCheckChange: event => dispatch(actions.setAdminCheck(parseInt(event.target.value, 10))),
  onStepChange: event => dispatch(actions.setAdminCheckStep(parseInt(event.target.value, 10))),
  onVideoStepChange: event => dispatch(actions.setVideoStep(parseInt(event.target.value, 10))),
  onMinusClick: () => dispatch(actions.decAdminCheck()),
  onPlusClick: () => dispatch(actions.incAdminCheck()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdCounter);



// WEBPACK FOOTER //
// ./src/containers/tools/AdCounter.js